import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProgressSpinnerModule } from '@shared/components';
import { ReviewQuestionsAndAnswersComponent } from './review-questions-and-answers.component';


@NgModule({
	imports: [
		CommonModule,
		ProgressSpinnerModule
	],
	declarations: [
		ReviewQuestionsAndAnswersComponent
	],
	exports: [
		ReviewQuestionsAndAnswersComponent
	]
})
export class ReviewQuestionsAndAnswersModule {}